import React from "react";

const periodOptions = [
  { label: "Weekly", value: "weekly" },
  { label: "2-weekly", value: "2-weekly" },
  { label: "4-weekly", value: "4-weekly" },
];

const weekDays = [
  { label: "Mon", value: "Mon" },
  { label: "Tue", value: "Tue" },
  { label: "Wed", value: "Wed" },
  { label: "Thu", value: "Thu" },
  { label: "Fri", value: "Fri" },
  { label: "Sat", value: "Sat" },
  { label: "Sun", value: "Sun" },
];

export default function WorkPeriodForm({
  value = { period: "", day: "" },
  onChange,
  disabled = false,
}) {
  // Handlers to update parent state
  const handlePeriodChange = (e) => {
    const newPeriod = e.target.value;
    // Reset day when period changes
    onChange?.({ period: newPeriod, day: "" });
  };

  const handleDayChange = (e) => {
    onChange?.({ period: value.period, day: e.target.value });
  };

  return (
    <div className="bg-gray-50 rounded-md p-6 max-w-xl w-full m-1 font-sans ">
      <div className="font-semibold text-xl mb-2">Create a new work period</div>
      <div className="text-gray-500 mb-7">
        Saving this template will allow it to be used across any team member
        profile.
      </div>
      <div className="mb-6">
        <div className="font-medium mb-2">Work period length</div>
        <div className="flex gap-8">
          {periodOptions.map((opt) => (
            <label
              key={opt.value}
              className="text-sm text-[#3b3b64] flex items-center gap-1.5 cursor-pointer"
            >
              <input
                type="radio"
                name="period"
                value={opt.value}
                checked={value?.period === opt.value}
                onChange={handlePeriodChange}
                className="accent-gray-500"
                disabled={disabled}
              />
              {opt.label}
            </label>
          ))}
        </div>
      </div>
      <div className="mb-8">
        <div className="font-medium mb-2">Next work period starts on</div>
        {value?.period === "weekly" ? (
          <div className="flex gap-4">
            {weekDays.map((d) => (
              <label
                key={d.value}
                className="text-sm text-[#3b3b64] flex items-center gap-1.5 cursor-pointer"
              >
                <input
                  type="radio"
                  name="day"
                  value={d.value}
                  checked={value.day === d.value}
                  onChange={handleDayChange}
                  className="accent-gray-500"
                  disabled={disabled}
                />
                {d.label}
              </label>
            ))}
          </div>
        ) : value?.period ? (
          <input
            type="date"
            value={value.day}
            onChange={handleDayChange}
            className="px-3 py-2 rounded-md border border-[#e3e3ef] text-sm text-[#3b3b64] bg-white focus:outline-none focus:ring-2 focus:ring-gray-200"
            placeholder="Pick a day"
            disabled={disabled}
          />
        ) : (
          <input
            type="date"
            disabled
            className="px-3 py-2 rounded-md border border-[#e3e3ef] text-sm text-gray-300 bg-gray-100"
            placeholder="Pick a day"
          />
        )}
      </div>
    </div>
  );
}
